import { useState, useCallback } from "react";
import { getSubproductosByEmpresa } from "../../../services/SubproductoTypeService.js";

const useSubproductos = (baseUrl, empresa, nombreEmpresa) => {
  const [subproductos, setSubproductos] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    if (!empresa) return;
    setLoading(true);
    try {
      const data = await getSubproductosByEmpresa(baseUrl, nombreEmpresa);
      setSubproductos(data);
    } catch (error) {
      console.error("Error fetching subproductos:", error);
    } finally {
      setLoading(false);
    }
  }, [baseUrl, empresa, nombreEmpresa]);

  return { subproductos, setSubproductos, loading, setLoading, fetchData };
};

export default useSubproductos;
